import { render, staticRenderFns } from "./AudioItem.vue?vue&type=template&id=3c31bd48&"
import script from "./AudioItem.vue?vue&type=script&lang=js&"
export * from "./AudioItem.vue?vue&type=script&lang=js&"
import style0 from "./AudioItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports